import React, { Component } from 'react'

import PropTypes from 'prop-types'

export default class Loader extends Component {
  static propTypes = {
    showLoader: PropTypes.bool.isRequired
  }

  static defaultProps = {
    showLoader: false
  }

  render() {
    return this.props.showLoader ? (
      <div className="loader">
        <img src="/img/rolling.svg" style={{ width: '100px', height: '100px' }} className="loader__image" alt="" />
      </div>
    ) : null
  }
}



// WEBPACK FOOTER //
// src/components/UI/Loader.js